import { CustomAttribute, SDCredentialValues, SubjectAttr } from "../../../types/types";

export function mapJsonEditorToFormValues(raw: any): SDCredentialValues {
  const rootData: any[] = raw?.data ?? [];

  const contextNode = rootData.find((n) => n.attribute === '@context');
  const contexts: string[] = contextNode?.data?.map((d: any) => d.data as string) ?? [''];

  const coreFieldNodes = rootData.filter(
    (n) => n.attribute !== '@context' && n.attribute !== 'credentialSubject'
  );
  const coreFields = coreFieldNodes.map((n: any) => ({
    key: n.attribute as string,
    value: (n.data?.[0]?.data ?? '') as string,
  }));

  const credSubjectNode = rootData.find((n) => n.attribute === 'credentialSubject');
  const csData: any[] = credSubjectNode?.data ?? [];

  const holderNode = csData.find((n) => n.attribute === 'holder');
  const holder = (holderNode?.data?.[0]?.data ?? '') as string;

  const typeNode = csData.find((n) => n.attribute === 'type');
  const subjectType = (typeNode?.data?.[0]?.data ?? '') as string;

  const customAttrNode = csData.find((n) => n.attribute === 'customAttribute');
  const customAttributes: CustomAttribute[] = (customAttrNode?.data ?? []).map((item: any) => {
    const itemData: any[] = item.data ?? [];
    const getField = (attr: string) =>
      itemData.find((d: any) => d.attribute === attr)?.data?.[0]?.data ?? '';
    return { type: getField('type'), name: getField('name'), value: getField('value') };
  });

  const subjectAttrs: SubjectAttr[] = csData
    .filter((n) => !['holder', 'type', 'customAttribute'].includes(n.attribute))
    .map((n: any) => ({
      key: n.attribute as string,
      value: (n.data?.[0]?.data ?? '') as string,
    }));

  return { contexts, coreFields, holder, subjectType, customAttributes, subjectAttrs };
}
